/**
 * The single per-navigation MENU-vs-BACK decision for the leading header affordance —
 * `true` means MENU (the drawer/rail toggle), `false` means BACK.
 *
 * A 1:1 MIRROR of the native predicates: iOS `AppRouter.topShowsMenu`
 * (`native-apps/ios/Symphony/Navigation/AppRouter.swift`) and Android `AppRoot.topShowsMenu`
 * (`native-apps/android/.../AppRoot.kt`). Native shows MENU on the home root and on any screen
 * reached from the drawer, and BACK on every drill-in. It is a PER-NAVIGATION decision, not a
 * route classification — the same screen shows MENU when opened from the rail/drawer and BACK when
 * reached by a CTA push, a deep-link or an agent `orion.navigate`.
 *
 * Home (`/`) is native's empty-path root, always MENU. Otherwise the answer is the per-navigation
 * `openedFromDrawer` flag, which on web is carried per history entry (see `lib/drawer-nav.ts`,
 * since web has no nav stack). The flag is passed in rather than read here so this stays a pure,
 * trivially-testable function.
 */
export function topShowsMenu(pathname: string, fromDrawer: boolean): boolean {
  return pathname === '/' || fromDrawer;
}
